import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@chakra-ui/react';

import { ReactComponent as RetryIcon } from '../../../../../assets/icons/chat/synchronize-refresh-icon.svg';

export type RetryMessageActionProps = {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
};

export const RetryMessageAction: React.FC<RetryMessageActionProps> = ({ className, onClick, disabled }) => {
    const { t } = useTranslation('translations');

    const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        onClick();
    };

    return (
        <Button
            variant="button-tab-outlined"
            className={className}
            onClick={handleClick}
            leftIcon={<RetryIcon />}
            isDisabled={disabled}
        >
            {t('chat-tab.message.retry')}
        </Button>
    );
};
